// @flow
import React from 'react';
import { Icon, Input, Button, Modal, Spinner } from '@elements';
import { map } from 'lodash';
import type { Medication } from '@types';
import { PlatformSwitch } from '@blocks';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { createNsTranslator } from '@helpers/helpers';

type Props = {
  onClose: Function,
  onAddNewItem: Function,
  medications: Array<Medication>,
  onDeleteItem: Function,
  t: Function,
  isLoading: boolean,
};

type State = {
  newItem: string,
  addMode: boolean,
};

class MedicationsFormModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      newItem: '',
      addMode: false,
    };
  }

  render() {
    const { onClose, medications, isLoading } = this.props;
    const { newItem, addMode } = this.state;
    const isSaveEnabled = String(newItem).trim().length > 0;

    const _ = createNsTranslator('timeline', this.props.t);

    const content = (mobile: boolean) => (
      <React.Fragment>
        {addMode &&
        <form method="POST" onSubmit={this.handleSubmit}>
          <div className={classNames(['addToList', mobile && 'mobile'])}>
            <Input
              name="name"
              autofocus
              mobileAutofocus
              placeholder={_('label/create_new_medication')}
              value={newItem}
              onChange={this.handleNewItemChange}
            />
            {isSaveEnabled &&
            <Button
              className={classNames('primary', mobile && 'addMobileButtonFull')}
              text={_('action/add', 'global')}
              onClick={this.handleAddNewItem}
              disabled={String(newItem).trim().length === 0}
            />
            }
          </div>
        </form>
        }
        {!addMode &&
        <div className={classNames(['addToListBtn', mobile && 'btn'])} onClick={this.handleAddItem}>
          <Icon iconName="plus" />&nbsp;{_('action/add_new_medication')}
        </div>
              }
        <ul className="list">
          {map(medications, (medication, index: number) => (
            <li key={`medicationItem${index}`}>
              <span>{medication.name}</span>
              {!isLoading && <Icon iconName="delete" size={20} onClick={this.handleDeleteMedication(medication.id)} />}
              {isLoading && <Spinner />}
            </li>
          ))}
        </ul>
      </React.Fragment>
    );

    return (
      <PlatformSwitch
        inject
        desktop={() => (
          <Modal className="widgetModal" onClose={onClose}>
            <div className="modalHeader">
              <span className="modalTitle">{_('label/medications')}&nbsp;&nbsp;{isLoading && <Spinner />}</span>
            </div>

            <div className="modalGrid">
              <div className="modalContainer">
                <div className="modalContent manageTagsContainer">
                  {content(false)}
                </div>
              </div>
            </div>
          </Modal>
        )}
        mobile={() => (
          <Modal className="asView" onClose={onClose}>
            <div className="modalHeader">
              <Button onClick={onClose}>
                <Icon iconName="close" className="icon" />
              </Button>
              <span className="title">{_('label/medications')}</span>
              {isLoading && <Spinner />}
              <Button onClick={onClose}>
                <Icon iconName="done" className="icon" />
              </Button>
            </div>
            <div className="problemsMobileContainer">
              <div>
                {content(true)}
              </div>
            </div>
          </Modal>
        )}
      />
    );
  }

  handleNewItemChange = (data: Object) => {
    this.setState({ newItem: data.value });
  };

  handleAddNewItem = () => {
    this.props.onAddNewItem(this.state.newItem);
    this.setState({ newItem: '', addMode: false });
  };

  handleDeleteMedication = (id: number) => () => {
    this.props.onDeleteItem(id);
  };

  handleAddItem = () => {
    this.setState({ addMode: true });
  };

  handleSubmit = (e: Object) => {
    e.stopPropagation();
    e.preventDefault();
    this.handleAddNewItem();
  };
}

export default withTranslation()(MedicationsFormModal);
